import { useEffect, useState } from "react";
import { fetchData } from "./Helpers";
import { FilterInput, RowFiltering } from '@refinitiv-ui/efx-grid/extensions';

export default function MidLevel() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData("Filings_Categories").then(res => {
      setData(res);
      setLoading(false);
    });
  }, []);

  function transformData(data) {
    data.map(item => {
      item.midLevelId = parseInt(item.midLevelId);
      return item;
    })
    return data;
  }

  useEffect(() => {
    const grid = document.getElementById("grid");
    const filterInputExt = new FilterInput();
    const rowFilteringExt = new RowFiltering();
    const columns = [
      { name: 'Mid Level Category ID', field: 'midLevelId', width: 2, scalable: true},
      { name: 'Mid Level Category', field: 'midLevelCategory', width: 8, scalable: true}
    ]

    grid.config = {
      rowHeight: 40,
      headerRowHeight: 60,
      columns: columns,
      dataModel: {
        data: transformData(data)
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      },
      rowFiltering: {
        disabledUI: true
      },
      extensions: [
        rowFilteringExt,
        filterInputExt
      ]
    };
  }, [data]);
  
  
  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>Mid Level Category Mapping</h4>
      <efx-grid id="grid" className="filings-grid"></efx-grid>
    </div>
  );
}